import { Injectable } from '@angular/core';
import { EventsService } from './events.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class GamesService {
    
    private interval;
    private running = false;

    private pixelPlaces = [
        '/',
        '/recherches',
        '/nouvelle-recherche',
        '/recherche',
        'widget',
        '/coups-de-coeur',
        '/communaute',
        '/le-salon/.*',
        '/communaute/private',
        '/communaute/public',
        '/communaute/favorites',
        '/salon/.*',
        '/conversations',
        '/conversations/.*',
        '/ma-page',
        '/favoris',
        '/a-propos-de-moi',
        '/mon-ideal',
        '/mes-albums',
        '/mon-compte',
        '/mes-choix',
        '/presentation-abonnements',
        '/abonnement-geek',
        '/abonnement-branche',
        '/mes-notifications',
        '/ma-localisation',
        '/contact',
        '/donnees-personnelles',
        '/mentions-legales',
        'profile',
    ]

    public pixelLocation = null;

    /**
     * Constructor
     */
    constructor(
        private eventsService: EventsService
    ) {}

    /**
     * Startup
     */
    public startup() {
        if (this.running) {
            return;
        }
        this.interval = setInterval( _ => {
            this.update();
        }, 1000 * 10);

        this.update();
        this.running = true;
    }

    /**
     * Update
     */
    private update() {
        // let places = environment.debug ? ['/'] : this.pixelPlaces;
        let places = this.pixelPlaces;
        this.pixelLocation = places[Math.floor(Math.random() * places.length)];
        this.eventsService.updatePixelPositionEvent.emit(this.pixelLocation);

        environment.debug && console.log("Pixel location: ", this.pixelLocation);
    }

    /**
     * Destroy
     */
    public destroy() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }

        this.pixelLocation = null;
        this.eventsService.updatePixelPositionEvent.emit(this.pixelLocation);
        this.running = false;
    }
}
